// PUCRCHASE JOURNEY 


// {
//   items: data.basket.transfers.map(transfer => ({
//     item_name: transfer.fromDestination.name + " to " + transfer.toDestination.name, // Name of the item
//     item_category2: data.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
//     quantity: 1 // Quantity of the item
//   }))
// }

// 2. Quote Book -> Quote Process
export function pushQuoteBook(quoteBookDetails) {
  window.dataLayer.push({
    event: 'quote book',
    ecommerce: quoteBookDetails,
  });
}
// {
//   items: createBookingResponse.basket.transfers.map(transfer => ({
//     item_name: transfer.fromDestination.name + " to " + transfer.toDestination.name, // Name of the item
//     item_category: "Book Now / Enquire",
//     item_category2: createBookingResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
//     quantity: 1 // Quantity of the item
//   }))
// }

// 3. Booking Continue -> Booking Journey Form Continue
export function pushBookingContinue(bookingContinueDetails) {
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: bookingContinueDetails,
  });
}

// 3.1 Make Request -> Booking Journey Make Request
export function pushBookingMakeRequest(bookingRequestDetails) {
  window.dataLayer.push({
    event: 'begin_checkout',            // name of the event. 
    ecommerce: bookingRequestDetails,
  });
}
// {
//   items: createBookingResponse.basket.transfers.map(transfer => ({
//     item_name: transfer.fromDestination.name + " to " + transfer.toDestination.name, // Name of the item
//     item_category: "Continue",
//     item_category2: createBookingResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
//     quantity: 1 // Quantity of the item
//   }))
// }

// 4. Booking Successfull -> Purchase Event -> Payment Form
export function pushBookingSuccessfull(ecommerce) {
  window.dataLayer.push({
    event: 'booking successfull',
    ecommerce
  });
}

//  {
//   currency: createBookingResponse.basket.currency[0],
//   value: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)), // order total.
//   transaction_id:  createBookingResponse.basket.bookingId, // transaction reference
//   coupon: createBookingResponse.basket.promoCode, // if coupon was applied to the order, include it here

//   items: createBookingResponse.basket.transfers.map(transfer => ({
//     item_name: transfer.fromDestination.name + " to " + transfer.toDestination.name, // Name of the item
//     price: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)), // Price of the item
//     item_category: transfer.transferType.description, // Category of the item
//     item_category2: createBookingResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
//     quantity: 1 // Quantity of the item
//   }))
// };


// NON PURCHASE EVENTS

// #1. Quote Change Event
export function pushQuoteChange(ecommerce) {
  window.dataLayer.push({
    event: 'quote change',
    ecommerce
  });
}

// #2. Quote Change Currency
export function pushChangeCurrency(currencyChangeDetails) {
  window.dataLayer.push({
    event: 'change currency',
    ecommerce: currencyChangeDetails,
  });
}


// #3. Booking Customer Login
export function pushBookingCustomerLogin(bookingCutomerLoginDetails) {
  window.dataLayer.push({
    event: 'booking customer login',
    ecommerce: bookingCutomerLoginDetails,
  });
}

// #4. Booking Forgot Password
export function pushBookingForgotPassword(bookingForgotPasswordDetails) {
  window.dataLayer.push({
    event: 'booking forgot password',
    ecommerce: bookingForgotPasswordDetails,
  });
}

// #5. Terms Loyality Points
export function pushTermsLoyalityPoint(termsLoyalityPointsDetails) {
  window.dataLayer.push({
    event: 'terms loyality points',
    ecommerce: termsLoyalityPointsDetails,
  });
}

// #6. Terms Promo Code
export function pushTermsPromoCode(termsPromoCodeDetails) {
  window.dataLayer.push({
    event: 'terms promo code',
    ecommerce: termsPromoCodeDetails,
  });
}

// #8. Booking Successful 
export function bookingRequestSuccessful(bookingRequestSuccessfulDetails){
  window.dataLayer.push({
    event: 'booking_request_successful',
    ecommerce: bookingRequestSuccessfulDetails,
  });
}
// #7. Request Checkout
export function requestTermsCheckout(termsRequestCheckout){
  window.dataLayer.push({
    event:'request_checkout',
    ecommerce: termsRequestCheckout
  })
}
